module.exports = __webpack_public_path__ + "media/images/online/online-wedding-recommended-image-b82ef2f746f75c84f177d643968a38e7.png";